import BetragsrechnerMixin from "../Mixins/BetragsrechnerMixin";
import {
  get,
} from "lodash-es";

// @vue/component
export default {
  name: "KostenabhaengigeFinanzierungRechner",
  mixins: [
    BetragsrechnerMixin,
  ],
  data() {
    return {
      labelWert: "_LBL_KOSTENABHAENGIGE_FINANZIERUNG_RECHNER_WERT_",
    };
  },
  computed: {
    optionsWert() {
      return {
        id: "wert",
        htmlId: this.htmlIdWert,
        label: this.labelWert,
        view: this.view,
        type: "float",
        addonBack: "_HTML_SUFFIX_EURO_",
        maxlength: 14,
        required: true,
        classesHorizontal: this.classesHorizontal,
        helpText: this.helpText,
        autoFocus: this.autoFocus,
        change: this.changeVorschauLocal,
      };
    },

    htmlIdWert() {
      return `${ this.htmlId }_wert`;
    },

    helpText() {
      if (this.kontext !== "beleg") {
        return get(this.model, "argument.bezeichnung");
      }
      return "";
    },

    errorLabels() {
      return {
        wert: {
          label: this.labelWert,
          link: true,
          id: this.htmlIdWert,
        },
      };
    },
  },
  created() {
    this.initErrorLabels();
  },
};
